import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminContacts from "@/pages/AdminContacts";
import AuthCallback from "@/pages/AuthCallback";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // If we come back from Emergent Google auth, session_id lives in the URL fragment.
  // Handle it synchronously during render (NOT inside useEffect) to avoid race with anything else.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/projects/:slug" element={<ProjectDetail />} />
      <Route path="/admin/contacts" element={<AdminContacts />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function SmoothScrollProvider() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only enable Lenis on the main landing page — detail/admin pages use native scroll.
    if (pathname !== "/") return;

    const lenis = new Lenis({
      duration: 1.35,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      lerp: 0.09,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="scanlines" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScrollProvider />
        <AppRouter />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#F5F5F5",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.15em",
          },
        }}
      />
    </div>
  );
}

export default App;
